import React from 'react';
import {TaskListItem} from '../../types/tasks.types';

const MAX_TEXT_LEN:number=16;

interface PropsType {
	createStarted:boolean;
	taskTitle: string;
	taskTitleInput: string;
	tasksList: TaskListItem[];
	updateTitle: (taskTitleInput:string,taskTitle:string) => void;
}

interface StateType {
	errMsg: string;
}

export class StepThree extends React.Component<PropsType, StateType> {

	constructor(props: PropsType) {
		super(props);
		this.state = {
			errMsg: ''
		};
	}

	myTitleAltered(inputText:string){
		if(this.props.createStarted)return;
		let taskTitleInput = inputText.replace(/[^a-zA-Z0-9 ]/g, "");
		let isTitleValid=true;
		let errMsg='';
		if(taskTitleInput.length<3){
			isTitleValid=false;
			if(taskTitleInput.length>0)errMsg='* 3 or more characters'
		}
		for(let i=0;i<this.props.tasksList.length;i++){
			if(this.props.tasksList[i].taskTitle.toLowerCase().replace(/_/g, ' ')===taskTitleInput.toLowerCase()){
				if(taskTitleInput!==this.props.taskTitleInput){//prevents err when create new task
					isTitleValid=false;
					errMsg='* task already exists';
				}
			}
		}

		this.setState({errMsg});

		let newTitle=taskTitleInput.replace(/ /g, '_');
		if(isTitleValid){
			this.props.updateTitle(taskTitleInput,newTitle);
		}else{
			this.props.updateTitle(taskTitleInput,'');
		}
	}

	render() {
		return(
			<div className='teachers-taskcreater-step'>
				<hr />
				<h3>Step 3{this.props.taskTitle!==''&&'  - Complete'}</h3>
				{this.props.taskTitle===''&&<p>Enter a title for this task</p>}
				{this.props.taskTitle!==''&&<p>Title chosen: {this.props.taskTitleInput}</p>}
				<input className="teachers-taskcreater-input" type='text' placeholder='Title here...' value={this.props.taskTitleInput} onChange={(e)=>this.myTitleAltered(e.target.value)} maxLength={MAX_TEXT_LEN}></input>
				<span className='teachers-task-note'>{this.state.errMsg}</span>
			</div>
		)
	}
}

